import { AxiosPromise } from 'axios';
import { IGetContracts } from '../models/employeesContract.model';
import axios from 'axios';

const uri = '/mgmt/employees/contract';

export const getContracts = (memberId: string): AxiosPromise<IGetContracts> => {
  return axios.get(`${uri}/${memberId}`);
}

export const createContract = (memberId: string, data: any): AxiosPromise => {
  return axios.post(`${uri}/${memberId}`, data);
};

export const deleteContract = (contractId: string): AxiosPromise => {
  return axios.delete(`${uri}/${contractId}`);
};
